import type { FC } from "react";
import { Suspense, lazy } from "react";

import { SkeletonForgotPasswordPage } from "./SkeletonForgotPasswordPage";
const ForgotPasswordPage = lazy(() => import("./ForgotPasswordPageDefault"));

const LazyForgotPasswordPage: FC = () => {
  return (
    <Suspense fallback={<SkeletonForgotPasswordPage />}>
      <ForgotPasswordPage />
    </Suspense>
  );
};

export { LazyForgotPasswordPage };
